import type { ThemeConfig } from '../types'
import { fieldJournalConfig as generated } from '../../generated/theme-presets'

// Field Journal: Warm naturalist notebook. Dashed borders, paper texture, fern/brass palette.
// Dark bark sidebar. Comfortable density. Pairs with Caveat accent font (--font-accent in CSS).
export const fieldJournalConfig: ThemeConfig = generated
